import {
  TransitionDirection,
  TransitionConfig,
  TransitionEvents,
} from './Transition.model';

export type {
  TransitionDirection,
  TransitionConfig,
  TransitionEvents,
};

export const DEFAULT_TRANSITION_CONFIG: Required<TransitionConfig> = {
  yOffset: 10,
  direction: 'none',
  duration: 0.2,
  enabled: true,
  animateHeight: true,
};

export const mergeTransitionConfig = (
  customConfig?: Partial<TransitionConfig>
): Required<TransitionConfig> => {
  return {
    ...DEFAULT_TRANSITION_CONFIG,
    ...customConfig,
  };
};

export const transitionVariants = {
  initial: (custom: { yOffset: number; direction: TransitionDirection }) => ({
    y: custom.direction === 'backward' ? -custom.yOffset : custom.yOffset,
    opacity: 0,
  }),
  animate: {
    y: 0,
    opacity: 1,
    willChange: 'transform',
  },
  exit: (custom: { yOffset: number; direction: TransitionDirection }) => ({
    y: custom.direction === 'backward' ? custom.yOffset : -custom.yOffset,
    opacity: 0,
  }),
};
